import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { BaseBusinessPostRequest } from '@/coreInfrastructureModule/axios/generated/baseBusinessManage';
import { IBaseBusinessManageRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessManageRepository';

/**
 * 新規に集計取引を作成する
 */
export class CreateNewBaseBusinessUseCase {
  private repository: IBaseBusinessManageRepository;

  /**
   * コンストラクタ
   * @param repository - 集計情報のリポジトリ
   */
  constructor(repository: IBaseBusinessManageRepository) {
    this.repository = repository;
  }

  /**
   * 新しい取引情報を作成する
   * @param business - 取引情報
   * @param aggregateBusinessId - 集計ID
   */
  public async Execute(business: IBusiness, aggregateBusinessId: string): Promise<INetworkResult<string, Error>> {
    if (!(business.customerName && business.customerNumber && business.salesDestinationName && business.salesDestinationNumber)) {
      console.error('取引情報がない');
      return {
        status: {
          type: 'error',
          error: Error('取引情報の作成に失敗しました'),
        },
      };
    }
    try {
      const request: BaseBusinessPostRequest = {
        postBaseBusinessInfo: {
          aggregateBusinessId: aggregateBusinessId,
          customerName: business.customerName,
          customerNumber: business.customerNumber,
          salesDestinationName: business.salesDestinationName,
          salesDestinationNumber: business.salesDestinationNumber,
          endUser: business.endUser,
          forecastForReceiptMemo: business.forecastForReceiptId,
          baseBusinessResponsibleUserIdList:
            business.baseBusinessResponsibleUsers?.map((user) => user.email).filter((email) => email !== undefined) ?? [],
          businessFreeColumnValues: business.businessFreeColumnValues
            ?.filter((column) => column.isConfigured && (column.target === 'base' || column.target === undefined))
            .map((column) => ({ columnNo: column.columnNo, value: column.value })),
        },
      };

      const result = await this.repository.post(request);

      if (result.status.type === 'error') {
        return {
          status: {
            type: 'error',
            error: Error('取引情報の作成に失敗しました'),
          },
        };
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: Error('取引情報の作成に失敗しました'),
        },
      };
    }
  }
}
